"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.is.js");

var _react = require("react");

var _useModel = _interopRequireDefault(require("../useModel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useBatchDerivedStateToModel = function useBatchDerivedStateToModel(model) {
  for (var _len = arguments.length, derivedSpace = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    derivedSpace[_key - 1] = arguments[_key];
  }

  var state = model();

  var _useState = (0, _react.useState)(function () {
    return {
      current: false
    };
  }),
      _useState2 = _slicedToArray(_useState, 1),
      flag = _useState2[0];

  var _useState3 = (0, _react.useState)(function () {
    var map = new Map();
    derivedSpace.forEach(function (ds, index) {
      var prevDerivedSpacePositionState = map.get(index - 1);
      var tmp = ds.callback(ds.source, ds.source, state, prevDerivedSpacePositionState);
      var derivedSpacePositionState = {
        source: ds.source,
        stateChanged: !Object.is(tmp, state),
        prev: prevDerivedSpacePositionState
      };
      map.set(index, derivedSpacePositionState);
      state = tmp;
    });
    return {
      current: map
    };
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      cachedMap = _useState4[0];

  if (flag.current) {
    derivedSpace.forEach(function (ds, index) {
      var derivedStatus = cachedMap.current.get(index);
      var source = derivedStatus.source,
          prev = derivedStatus.prev;
      var tmp = ds.callback(ds.source, source, state, prev);
      derivedStatus.source = ds.source;
      derivedStatus.stateChanged = !Object.is(tmp, state);
      state = tmp;
    });
  }

  if (!flag.current) {
    flag.current = true;
  }

  model.silent(state);
  (0, _useModel.default)(model);
  return [model()];
};

var _default = useBatchDerivedStateToModel;
exports.default = _default;